const HttpBackend = require('i18next-http-backend/cjs');

function getDivisableCount(dividend, divisor, count = 0) {
  const quotient = ~~(dividend / divisor);
  const remainder = dividend % divisor;

  if (quotient > divisor) {
    return getDivisableCount(quotient, divisor, count + 1);
  }

  return [quotient, remainder, count];
}
/** @type {import('next-i18next').UserConfig} */
const nextI18NextConfig = {
  i18n: {
    defaultLocale: 'ko',
    locales: ['en', 'ko'],
  },
  fallbackLng: false,
  serializeConfig: false,
  use: [
    {
      init: (i18next) => {
        i18next.services.formatter.add('simplifyNumber', (value, lng) => {
          const units = {
            ko: ['만', '억', '조', '경', '해'],
          };
          const divisors = {
            ko: 10000,
          };

          const unit = units[lng] || ['K', 'M', 'B', 'T', 'Q'];
          const divisor = divisors[lng] || 1000;

          const [big, small, index] = getDivisableCount(value, divisor);

          if (big > 0) {
            const remainder = small / divisor;
            if (remainder >= 0.05 && remainder < 0.95) {
              return `${big.toLocaleString()}.${Math.round(remainder * 10)}${
                unit[index]
              }`;
            }

            return `${Math.round(big + remainder).toLocaleString()}${
              unit[index]
            }`;
          }

          return small.toLocaleString();
        });
      },
      type: '3rdParty',
    },
    HttpBackend,
  ],

  backend: {
    loadPath: (lng) => {
      const isServer = typeof window === 'undefined';
      const isStaging = process.env.NEXT_PUBLIC_ENV === 'staging';
      const isProduction = process.env.NEXT_PUBLIC_ENV === 'production';

      const release = process.env.NEXT_PUBLIC_RELEASE;

      const assetPrefix = isProduction
        ? `/assets/${release}`
        : isStaging
        ? `/assets/${release}`
        : '';
      if (isServer) {
        return `/locales/${lng}/common.json`;
      }

      return assetPrefix + `/_next/static/media/${lng}/common.json`;
    },
  },
};

module.exports = nextI18NextConfig;
